'use client';

import type { LucideIcon } from 'lucide-react';
import { Inbox } from 'lucide-react';

type Props = {
  title: string;
  description: string;
  icon?: LucideIcon;
};

export function AdminEmptyState({ title, description, icon: Icon = Inbox }: Props) {
  return (
    <div className="rounded-2xl border border-dashed border-nature-muted/30 bg-bg/60 p-10 text-center">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-nature-bg/80 text-nature-muted">
        <Icon className="h-6 w-6" aria-hidden />
      </div>
      <p className="text-base font-semibold text-nature-text">{title}</p>
      <p className="mx-auto mt-2 max-w-md text-sm text-nature-muted">{description}</p>
    </div>
  );
}
